import "@/components/BrandMark/BrandMark.scss";

interface BrandMarkProps {
  inverted?: boolean;
}

/** Wordmark with a small Swiss cross; the text alone gives it its accessible name. */
function BrandMark({ inverted = false }: BrandMarkProps) {
  return (
    <span className={`brand-mark${inverted ? " brand-mark--inverted" : ""}`}>
      <svg
        className="brand-mark__cross"
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
      >
        <rect width="32" height="32" rx="7" fill="#d52b1e" />
        <path d="M13 7h6v6h6v6h-6v6h-6v-6H7v-6h6z" fill="#fff" />
      </svg>
      <span className="brand-mark__name">Superhosts</span>
    </span>
  );
}

export default BrandMark;
export type { BrandMarkProps };
